import { GeometryUtils as G } from '../utils/Geometry.js';
export { Tangent };
class Tangent {
    constructor({ id, sourcePoint, targetPoint, sourceTrajectory, targetTrajectory, direction, vector, sourceRotation, targetRotation, minX, maxX, minY, maxY, width }) {
        this.id = id !== null && id !== void 0 ? id : Tangent.nonce;
        this.sourcePoint = sourcePoint;
        this.targetPoint = targetPoint;
        if (sourceTrajectory !== undefined) {
            this.sourceTrajectory = sourceTrajectory;
        }
        if (targetTrajectory !== undefined) {
            this.targetTrajectory = targetTrajectory;
        }
        this.direction = direction;
        this.vector = vector;
        this.sourceRotation = sourceRotation;
        this.targetRotation = targetRotation;
        if (!width) {
            throw 'error';
        }
        this.width = width;
        const l = 0.5 * width / Math.hypot(this.vector[0], this.vector[1]);
        const perp1 = [-this.vector[1] * l, this.vector[0] * l];
        const perp2 = [this.vector[1] * l, -this.vector[0] * l];
        const points = [
            [this.sourcePoint[0] + perp1[0], this.sourcePoint[1] + perp1[1]],
            [this.sourcePoint[0] + perp2[0], this.sourcePoint[1] + perp2[1]],
            [this.targetPoint[0] + perp1[0], this.targetPoint[1] + perp1[1]],
            [this.targetPoint[0] + perp2[0], this.targetPoint[1] + perp2[1]]
        ];
        const box = G.boundingBox(points);
        this.minX = minX !== null && minX !== void 0 ? minX : box.minX;
        this.maxX = maxX !== null && maxX !== void 0 ? maxX : box.maxX;
        this.minY = minY !== null && minY !== void 0 ? minY : box.minY;
        this.maxY = maxY !== null && maxY !== void 0 ? maxY : box.maxY;
    }
    static get nonce() {
        return Tangent._nonce++;
    }
    get reverseDirection() {
        return [-this.direction[0], -this.direction[1]];
    }
    isSource(trajectory) {
        return trajectory === this.sourceTrajectory;
    }
    isTarget(trajectory) {
        return trajectory === this.targetTrajectory;
    }
    getOtherTrajectory(trajectory) {
        if (this.isSource(trajectory)) {
            return this.targetTrajectory;
        }
        else if (this.isTarget(trajectory)) {
            return this.sourceTrajectory;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getPoint(trajectory) {
        if (this.isSource(trajectory)) {
            return this.sourcePoint;
        }
        else if (this.isTarget(trajectory)) {
            return this.targetPoint;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getOtherPoint(trajectory) {
        if (this.isSource(trajectory)) {
            return this.targetPoint;
        }
        else if (this.isTarget(trajectory)) {
            return this.sourcePoint;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getDirection(trajectory) {
        if (this.isSource(trajectory)) {
            return this.direction;
        }
        else if (this.isTarget(trajectory)) {
            return this.reverseDirection;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getReverseDirection(trajectory) {
        if (this.isSource(trajectory)) {
            return this.reverseDirection;
        }
        else if (this.isTarget(trajectory)) {
            return this.direction;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getRotation(trajectory) {
        if (this.isSource(trajectory)) {
            return this.sourceRotation;
        }
        else if (this.isTarget(trajectory)) {
            return -this.targetRotation;
        }
        else {
            throw new Error('Invalid');
        }
    }
    getReverseRotation(trajectory) {
        if (this.isSource(trajectory)) {
            return -this.sourceRotation;
        }
        else if (this.isTarget(trajectory)) {
            return this.targetRotation;
        }
        else {
            throw new Error('Invalid');
        }
    }
    clone() {
        return new Tangent({
            id: this.id,
            sourcePoint: this.sourcePoint,
            targetPoint: this.targetPoint,
            sourceTrajectory: this.sourceTrajectory,
            targetTrajectory: this.targetTrajectory,
            direction: this.direction,
            vector: this.vector,
            sourceRotation: this.sourceRotation,
            targetRotation: this.targetRotation,
            width: this.width
        });
    }
}
Tangent._nonce = 0;
//# sourceMappingURL=Tangent.js.map